import { Pallet, RobotTypeEnum } from '@/generated/model/models'

export const robots: any[] = [
  {
    id: RobotTypeEnum.GENERIC,
    title: 'Generic (JSON)',
    pallets: ['EUR', 'INDU', 'US', 'JP', 'AU', 'IL', 'CHEM', 'CUSTOM'],
    infeeds: [1, 2, 3, 4]
  },
  {
    id: RobotTypeEnum.RC10_UR,
    title: 'RC10 (UR)',
    pallets: ['EUR', 'INDU', 'US', 'JP', 'AU', 'IL', 'CHEM'],
    infeeds: [1, 2, 3, 4]
  },
  {
    id: RobotTypeEnum.RC12,
    title: 'RC12',
    pallets: ['EUR', 'INDU', 'US', 'JP', 'AU', 'IL', 'CHEM'],
    infeeds: [1, 2, 3, 4]
  },
  {
    id: RobotTypeEnum.RC20,
    title: 'RC20',
    pallets: ['EUR', 'INDU', 'US', 'JP', 'AU', 'IL', 'CHEM'],
    infeeds: [1, 2, 3, 4]
  },
  {
    id: RobotTypeEnum.RI20_FANUC,
    title: 'RI20 (FANUC)',
    pallets: ['EUR', 'INDU', 'US', 'JP', 'AU', 'IL', 'CHEM'],
    infeeds: [2, 3]
  },
  {
    id: RobotTypeEnum.RI20_KUKA,
    title: 'RI20 (KUKA)',
    pallets: ['EUR', 'INDU', 'US', 'JP', 'AU', 'IL', 'CHEM'],
    infeeds: [2, 3]
  },
  {
    id: RobotTypeEnum.CUSTOM_SOLUTION,
    title: 'Custom Solution',
    pallets: ['EUR', 'INDU', 'US', 'JP', 'AU', 'IL', 'CHEM'],
    infeeds: [2, 3]
  }
]

export const userProfiles: any[] = [
  {
    id: 'service',
    name: 'FlexLink Service'
  },
  {
    id: 'maintenance',
    name: 'Maintenance'
  },
  {
    id: 'supervisor',
    name: 'Production Supervisor'
  },
  {
    id: 'operator',
    name: 'Machine Operator'
  },
  {
    id: 'basic',
    name: 'Basic User'
  }
]

export const defaultConveyorInfeedCollection = [
  { id: 1, text: 'robotStep.left', value: 'LEFT', status: false },
  { id: 2, text: 'robotStep.centerLeft', value: 'CENTER_LEFT', status: false },
  { id: 3, text: 'robotStep.centerRight', value: 'CENTER_RIGHT', status: false },
  { id: 4, text: 'robotStep.right', value: 'RIGHT', status: false }
]

export const defaultPalletTypes: Pallet[] = [
  { palletType: 'EUR', width: 800, length: 1200, height: 145 },
  { palletType: 'INDU', width: 1000, length: 1200, height: 145 },
  { palletType: 'US', width: 1016, length: 1219, height: 145 },
  { palletType: 'JP', width: 1100, length: 1100, height: 145 },
  { palletType: 'AU', width: 1168, length: 1168, height: 145 },
  { palletType: 'IL', width: 770, length: 1190, height: 145 },
  { palletType: 'CHEM', width: 1200, length: 1200, height: 145 },
  { palletType: 'CUSTOM', width: 800, length: 1200, height: 145 }
]

export const defaultPallet: Pallet = {
  palletType: 'EUR',
  length: 1200, width: 800, height: 145,
  overhangL: 0, overhangR: 0, overhangT: 0, overhangB: 0,
}

export const gripperWidthInterval = {
  min: 0,
  max: 2000
}

export const gripperLengthInterval = {
  min: 0,
  max: 2000
}

export const defaultPusherMaxBoxWidth = 200
export const defaultMaxBoxLengthInline3 = 230
export const defaultMaxBoxLength2Section = 360
